import utiles from "@/modules/Shared/utiles/utiles";
import DestinoService from "../services/DestinoService"
import Swal from "sweetalert2";

const DestinoSV = new DestinoService();

export default
{
    namespaced: true,
    modules: {
        utiles
    },
    state:
    {
        listDestinos: [],
        destino:
        {
            nombre: "",
            descripcion: ""
        },

        destinoDefault:
        {
            nombre: "",
            descripcion: ""
        },

        loading: false
    },

    mutations:
    {
        setDestino(state, payload)
        {
            state.destino = Object.assign({}, payload)
        },

        setDestinos(state, payload)
        {
            state.listDestinos = payload
        },

        editDestino(state, destino)
        {
            state.destino = destino
        },

        resetDestino(state)
        {
            state.destino = Object.assign({}, state.destinoDefault)
        }
    },


    actions:
    {
        async getDestinosAxios({commit,state})
        {
            state.loading = true;

            try{

                const data = await DestinoSV.getAll();

                state.loading = false;

                commit('setDestinos', data)

            }catch(error)
            {
                console.log(error)

                state.loading = false;
            }
        },

        async createDestinoAxios({commit, dispatch, state})
        {
            commit('utiles/alertLoading')
            try
            {
                const data = await DestinoSV.create(state.destino)

                commit('resetDestino')

                commit('utiles/alertConfirm', 'Se registró un nuevo destino')

                dispatch('getDestinosAxios')
            }
            catch(error)
            {
                console.log(error)

                commit('utiles/alertError')
            }
        },

        async updateDestinoAxios({commit, dispatch, state})
        {
            commit('utiles/alertLoading')
            try
            {
                const data = await DestinoSV.update(state.destino)

                commit('resetDestino')

                commit('utiles/alertConfirm', 'Se actualizó el destino')

                dispatch('getDestinosAxios')
            }
            catch(error)
            {
                console.log(error)

                commit('utiles/alertError')
            }
        },

        async deleteDestinoAxios({commit, dispatch, state}, id)
        {
           const confirm = await Swal.fire({
                title: "¿Desea eliminar este destino?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: "CONFIRMAR"
            })

            if(!confirm.isConfirmed){return }

            commit('utiles/alertLoading')
            try
            {
                await DestinoSV.delete(id)

                commit('utiles/alertConfirm', 'Se eliminó el destino')

                dispatch('getDestinosAxios')
            }
            catch(error)
            {
                console.log(error)

                commit('utiles/alertError')
            }
        },
    }

}
